import React from "react";
import TelegramIcon from "@mui/icons-material/Telegram";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import { FormattedMessage } from "react-intl";

const style = {
	socWrapper: `pt-4 lg:basis-1/2`,
	titleWrapper: `mb-2 text-center`,
	title: `relative text-lg tracking-wide text-white`,
	socLinks: `flex gap-4 items-center justify-center mb-2`,
	socLink: `text-2xl`,
	btnBlock: `flex items-center justify-center mb-4 text-center`,
	supportBtn: `bg-blue w-[400px] flex items-center py-2 text-md justify-center text-white w-full rounded-lg transition hover:shadow-[0_10px_25px_0_#4430D0]`,
	overall: `text-center text-sm`,
};

const Socials = () => {
	return (
		<div className={style.socWrapper}>
			<div className={style.btnBlock}>
				<a
					className={style.supportBtn}
					rel='noreferrer'
					target='_blank'
					href='#'
				>
					<FormattedMessage id='support' />
					<span>
						<TelegramIcon
							className='ml-2 bg-[#0088CC] p-1 rounded-full'
							fontSize='medium'
						/>{" "}
					</span>
				</a>
			</div>
			<div className={style.titleWrapper}>
				<h2 className={style.title}>
					<FormattedMessage id='socials' />
				</h2>
			</div>
			<div className={style.socLinks}>
				<a className={style.socLink} rel='noreferrer' target='_blank' href='#'>
					<TelegramIcon className='hover:text-[#0088CC]' fontSize='inherit' />
				</a>
				<a className={style.socLink} rel='noreferrer' target='_blank' href='#'>
					<InstagramIcon className='hover:text-[#e95950]' fontSize='inherit' />
				</a>
				<a className={style.socLink} rel='noreferrer' target='_blank' href='#'>
					<YouTubeIcon className='hover:text-[#FF0000]' fontSize='inherit' />
				</a>
			</div>
			<p className={style.overall}>
				Restart, Hayotni tartibga keltirish onlayn kursi. 2023 ⓒ
			</p>
		</div>
	);
};

export default Socials;
